module.exports = __webpack_public_path__ + "img/italo.88e03a6d.webp";